import { fetchApi } from "./fetchApi";

export default {
  list() {
    return fetchApi({
      method: "get",
      url: "/api/user",
    });
  },
  ochinList() {
    return fetchApi({
      method: "get",
      url: "/api/user/ochin",
    });
  },
  async import(id, serviceAreaId) {
    if (!id) throw new Error("id is required");
    if (!serviceAreaId) throw new Error("serviceAreaId is required");

    return fetchApi({
      method: "post",
      url: `/api/userImport/${serviceAreaId}/user/${id}`,
    });
  },
  async search(data) {
    const response = await fetchApi({
      data,
      method: "post",
      url: "/api/user/search",
    });

    return response.data;
  },
  async update({ active, email, phone, role, username, firstName, lastName }) {
    const response = await fetchApi({
      data: {
        active: Boolean(active),
        email,
        firstName,
        lastName,
        phone,
        role,
      },
      method: "put",
      url: `/api/user/${username}`,
    });

    return response.data.result;
  },
};
